// extracted by mini-css-extract-plugin
module.exports = {"Banner":"Banner_Banner__1x2vp","Banner-Text":"Banner_Banner-Text__3w34z"};